import { RawOrganisationData } from '@frontend/core'
import {
  CustomFilterState,
  FilterTypes,
  getFilterState,
  runCheck
} from '@frontend/core/lib/utils/filter'
import { useMemo } from 'react'
import { useFilterReducer } from '../../modules/filter/filter'

export type OrganisationFilterTypeKeys = 'name'

export type OrganisationFilters = {
  name: FilterTypes<string, 'name', OrganisationFilterTypeKeys>
}

export const defaultOrganisationFilterState: OrganisationFilters = {
  name: {
    key: 'name',
    label: 'Name',
    type: 'searchStr' as const,
    value: '',
    options: []
  }
}

export function getFilterOrganisationData(organisation: RawOrganisationData) {
  // Add custom filter data here if needed in future
  return {
    ...organisation
  }
}

export const useOrganisationsFilter = (
  data: RawOrganisationData[],
  customFilterState: CustomFilterState<OrganisationFilters>
) => {
  const filterState = useMemo(
    () => getFilterState(customFilterState, defaultOrganisationFilterState),
    []
  )

  const { filters, updateFilterValue, updateFilterOptions } =
    useFilterReducer(filterState)

  const filteredData = useMemo(() => {
    if (!data) return []

    return data.filter((organisation) => {
      const data = getFilterOrganisationData(organisation)

      return Object.keys(filters).every((filterKey) => {
        const filter = filters[filterKey as keyof typeof filters]
        const itemValue = data[filterKey as keyof typeof data]
        return runCheck(filter, itemValue)
      })
    })
  }, [filters, data])

  return {
    filteredData,
    filters,
    updateFilterValue,
    updateFilterOptions
  }
}
